import type { AgentDataset } from '@inference.engine/agentic';
import { describeShape, structuredView } from '@inference.engine/agentic/data-view';
import type { DataEntrySummaryDto } from '@inference.engine/api-client/web';

/** One key an agent holds, as the Data tab lists it. */
export interface DataRow {
  key: string;
  /** An author's dataset, or something the agent saved. */
  source: 'dataset' | 'saved';
  /** What the author or the agent said it holds. */
  detail: string;
  mediaType: string;
  bytes: number;
  shape: string;
  truncated: boolean;
}

const encoder = new TextEncoder();

export function datasetRows(datasets: readonly AgentDataset[]): DataRow[] {
  return datasets.map((dataset) => ({
    key: dataset.key,
    source: 'dataset',
    detail: dataset.description,
    mediaType: dataset.mediaType,
    bytes: encoder.encode(dataset.content).length,
    shape: describeShape(structuredView(dataset.content, dataset.mediaType)),
    truncated: false,
  }));
}

export function savedRows(entries: readonly DataEntrySummaryDto[]): DataRow[] {
  return entries.map((entry) => ({
    key: entry.key,
    source: 'saved',
    detail: entry.inputSummary,
    mediaType: entry.mediaType,
    bytes: entry.bytes,
    shape: entry.shape,
    truncated: entry.truncated,
  }));
}
